
import { sendMail } from "./routes/send-mail.js";
import { sanitizeFunctions } from "../../sanitize.js";
import { debounce } from "../../../../js/optimize.js";

/**
 * 
 * 
 * 
 * 
 */
export class ContactForm{

    //------------------------------------------ STATIC ----------------------------------------------

    static instances = [];

    /**
     * Recherche les block form dans la page
     */
    static init(){
        const instances = [...document.querySelectorAll("form")].map($form => new ContactForm($form));
    }

    //------------------------------------------ INSTANCE ----------------------------------------------

    dom = {
        getElements:     () => [...this.element.querySelectorAll(".ELEMENT")],
        submit:          () => this.element.querySelector("button"),
        getGlobalNotif:  () => document.getElementById("notification"),
        getMessageNotif: () => document.getElementById("notification-message"),
        getCloseNotif:   () => document.getElementById("notification-close"),
        getField:        ($formElement) => $formElement.closest(".FIELD")
    };
    element = null;
    sanitize = sanitizeFunctions;
    nonceName = false;

    /**
     *
     * @param {Element} $form
     */
    constructor($form) {
        this.element = $form;
        this.nonceName = $form.dataset.nonceName;//console.log({nonceName:this.nonceName});
        const $submit = this.dom.submit();
        if ($submit) {
            $submit.addEventListener("click", this.onSubmit);
        }
        //
        this.dom.getElements().forEach($formElement => {
            this.applyDefaultValue($formElement);
            if ($formElement.type === "checkbox") {         
                $formElement.addEventListener("change", this.onField);
            } else {
                $formElement.addEventListener("blur", this.onField);
                $formElement.addEventListener("keyup", debounce(1000, this.onField));    
            }
        });

        const $closeNotif = this.dom.getCloseNotif();
        if($closeNotif){
            $closeNotif.addEventListener("click", e => {
                e.preventDefault();
                const $notif = this.dom.getGlobalNotif();
                if($notif){
                    $notif.classList.remove("HAS_SUCCESS");
                    $notif.classList.remove("HAS_ERROR");
                }
            })
        }
    }
    
    /**
     * @param {Event} e 
     */
    onField = (e) => {
        const $formElement = e.target;
        if(! this.isDefaultValue($formElement))
            this.check($formElement);
        else this.setErrorNotif($formElement, false);
    }

    /**
     * @param {Event} e 
     */
    onSubmit = (e) => {
        e.preventDefault();
        const datas = {};
        const ok = this.dom.getElements().map($formElement => {
            const value = this.getValue($formElement);
            let {sanitize, value:defaultValue} = $formElement.dataset;
            if(defaultValue === "true") defaultValue = true;
            else if(defaultValue === "false") defaultValue = false;
            const {required} = $formElement;
            datas[$formElement.name] = {value, defaultValue, sanitize, required};
            return this.check($formElement);
        }).every(v => v);
        if(ok){
            const $hiddenNonce = document.querySelector(`[name=${this.nonceName}]`);
            if($hiddenNonce){
                const nonce = $hiddenNonce.value;
                //datas._wp_http_referer = {value:document.querySelector("[name=_wp_http_referer]").value};
                sendMail(datas, nonce).then(response=>{
                    const $notif = this.dom.getGlobalNotif();
                    if($notif){
                        const {message, success} = response.datas;
                        const errorClass = success ? "" : " HAS_ERROR";
                        if(success){
                            $notif.classList.add("HAS_SUCCESS");
                        } else {
                            $notif.classList.add("HAS_ERROR");
                        }
                        const $message = this.dom.getMessageNotif();
                        if($message){
                            $message.innerHTML = message;
                        }
                    }
                    this.resetForm();
                    location.href = "#";
                    console.log({response});
                });
            }
        }
    }

    /**
     * 
     * @param {Element} $formElement 
     * @returns {boolean}
     */
    isDefaultValue($formElement){
        let {value} = $formElement.dataset;
        if($formElement.type === "checkbox"){
            value = value === "true";
            return $formElement.checked === value;
        } else {
            return $formElement.value === value;
        }
    }

    /**
     * 
     * @param {Element} $formElement 
     */
    applyDefaultValue = ($formElement) => {
        const {value} = $formElement.dataset;
        if ($formElement.type === "checkbox"){
            $formElement.checked = value === "true";
        } else {
            $formElement.value = value;
        }
        this.setRequiredNotif($formElement, false);
        this.setErrorNotif($formElement, false);
    }

    /**
     * Renvoie la valeur d'un élément de form
     * @param {Element} $formElement 
     * @returns {string|boolean}
     * - si checkbox, renvoie un boolean
     * - tous les autres cas : string
     */
    getValue($formElement) {
        return $formElement.type === "checkbox" ? $formElement.checked : $formElement.value.trim();
    }

    /**
     * Vérifie si la valeur du champs est conforme ou non
     * Applique une erreur si non conforme
     * @param {Element} $formElement 
     * @returns {boolean}
     */
    check($formElement) {
        const value = this.getValue($formElement);
        // si required
        if($formElement.required && typeof value === "string" && value.length === 0){
            return ! this.setRequiredNotif($formElement, true);
        } else this.setRequiredNotif($formElement, false);
        // si vide (et pas requis)
        if(typeof value === "string" && value.length === 0)
            return true;
        // sanitize
        const toSanitize = $formElement.dataset.sanitize;
        if(toSanitize && typeof this.sanitize[toSanitize] === "function"){
            const sanitized = this.sanitize[toSanitize](value);
            return ! this.setErrorNotif($formElement, !sanitized);
        }
        return true;
    }

    /**
     * 
     * @param {Element} $formElement 
     * @param {boolean} HAS_ERROR indique si on a une erreur (TRUE) ou non (FALSE)
     * @returns {boolean} HAS_ERROR
     */
    setErrorNotif($formElement, HAS_ERROR){
        const $field = this.dom.getField($formElement);
        if(! $field) return false;
        HAS_ERROR 
            ? $field.classList.add("HAS_ERROR")
            : $field.classList.remove("HAS_ERROR");
        return HAS_ERROR;
    }

    setRequiredNotif($formElement, HAS_REQUIRED_EMPTY){
        const $field = this.dom.getField($formElement);
        if(! $field) return false;
        HAS_REQUIRED_EMPTY
            ? $field.classList.add("HAS_REQUIRED_EMPTY")
            : $field.classList.remove("HAS_REQUIRED_EMPTY");
        return HAS_REQUIRED_EMPTY;
    }
    
    /**
     * 
     */
    resetForm(){
        this.dom.getElements().forEach(this.applyDefaultValue);
    }

}